import { useParams } from "react-router-dom";
import { CONNECT_COUNTRIES } from "@/config/connect-countries";
import { DIASPORA_ORIGINS } from "@/config/diaspora-origins";
import { ConnectCountryPage } from "./ConnectCountryPage";
import { GenericCountryPage } from "./GenericCountryPage";
import { DiasporaConnectPage } from "./DiasporaConnectPage";

export default function DynamicCountryRoute() {
  const { countrySlug } = useParams<{ countrySlug: string }>();

  if (!countrySlug) {
    return <GenericCountryPage slug="" />;
  }

  // Check diaspora origin pages (call-from-us, call-from-uk, etc.)
  const diasporaConfig = DIASPORA_ORIGINS[countrySlug];
  if (diasporaConfig) {
    return <DiasporaConnectPage origin={diasporaConfig} />;
  }

  // Check configured country pages (ethiopia, nigeria, etc.)
  const countryConfig = CONNECT_COUNTRIES[countrySlug];
  if (countryConfig) {
    return <ConnectCountryPage country={countryConfig} />;
  }

  // Fallback to generic country page
  return <GenericCountryPage slug={countrySlug} />;
}
